import { fonts } from '../../theme/typography';
import { createMuiStyles } from '../../utils/mui';

export const verificationPageStyles = createMuiStyles({
  card: {
    p: 5,
    borderRadius: '0.5rem',
    boxShadow: 10,
    textAlign: 'center',
    maxWidth: '32em',
  },
  svg: {
    height: '15rem',
    width: '15rem',
    mb: 5,
  },
  title: {
    mb: 2.5,
    fontFamily: fonts.heading,
    fontWeight: 'Bold',
    color: 'success.main',
  },
});
